import * as Api from '@ViewModels';
import { FC, useMemo } from 'react';
import { THEME } from '../../../../components-v2/Theme/theme';
import { FavoriteIconEmpty } from '../../../../components/svgs/icons/FavoriteIconEmpty';
import { FavoriteIconFull } from '../../../../components/svgs/icons/FavoriteIconFull';
interface TagFavoriteForIndicatorProps {
	favoriteFor: Api.FavoriteFor;
}

const { colors } = THEME;

export const TagFavoriteForIndicator: FC<TagFavoriteForIndicatorProps> = ({ favoriteFor }) => {
	const favoriteTagColorMap = useMemo(
		() => ({
			[Api.FavoriteFor.Account]: colors.warning.main,
			[Api.FavoriteFor.User]: colors.info.main,
			[Api.FavoriteFor.None]: colors.icon.gray,
		}),
		[]
	);

	return favoriteFor === Api.FavoriteFor.None ? (
		<FavoriteIconEmpty color={favoriteTagColorMap[favoriteFor]} />
	) : (
		<FavoriteIconFull color={favoriteTagColorMap[favoriteFor]} />
	);
};
